<template>
  <div>
    <a
    class="banner"
    :href="item.link"
    target="_blank"
    :style="{'backgroundImage':`url(${!$store.state.isMobile?item.picture:item.mobilepicture})`}">
      <slot></slot>
      <!-- <img v-if="!isMobile" :src="item.picture" alt="" style="width:100%;vertical-align: middle">
      <img v-else :src="item.mobilepicture" alt="" style="width:100%;vertical-align: middle"> -->
    </a>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: ['item']
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

a
  display: flex
  align-items: center
  justify-content: center
  min-height: 500px
  background-position: top center
  background-size: cover
  +mobile
    min-height: 350px

</style>
